import {interval, Observable, of, switchMap} from "rxjs";


export class Stats {
  businessDomain;
  businessId;
  stationId;
  stationToken;
  statMap = {}

  constructor(businessDomain, businessId, stationId, stationToken) {
    this.businessDomain = businessDomain;
    this.businessId = businessId;
    this.stationId = stationId;
    this.stationToken = stationToken;
    if (localStorage['stats']==null) {
      localStorage['stats'] = "{}"
    } else {
      this.statMap = JSON.parse(localStorage['stats']);
    }
  }

  addContent(tag, contentType, contentId, duration) {
    console.log(tag, contentType, contentId, duration);
    const date = new Date();
    let time = (date.getTime() % (3600000)) / 1000;
    let d1 = duration;
    let stat = null;
    while(d1>1.0)  // 1.0 sec min
    {
      const dur = Math.min(d1, time);
      const key = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate() + '.' + date.getHours() + '.' + tag + '.'+contentType+'.' + contentId;
      stat = this.statMap[key];
      if (stat==null) {
        this.statMap[key] = stat = {
          count: 0,
          duration: 0.0
        }
      }

      stat.duration += dur;
      console.log("key=" + key + ", dur=" + dur);
      d1-=dur;
      time = 3600;
      date.setTime(date.getTime() - 3600000 )
    }

    if (stat!=null) {
      stat.count++;
    }
  }

  start(): Observable<any> {
    return interval(2 * 60 * 1000).pipe(
      switchMap( a => this.posStats())
    )
  }

  posStats(): Observable<any> {
    if (this.statMap!=null && Object.keys(this.statMap).length > 0) {
      return new Observable<any>( sub => {
        const url = "https://pop.signage.me/stationStats.ashx?businessId=" + this.businessId + "&stationId=" + this.stationId + "&stationToken=" + this.stationToken + "&command=write";
        const data = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.statMap)
        }
        fetch(url, data).then(response => {
          response.text().then(txt => {
            this.statMap = {};
            localStorage['stats'] = JSON.stringify(this.statMap);

            sub.next('stats');
            sub.complete();
          })

        }).catch(error => {
          // ignore send if no internet and try next time
          localStorage['stats'] = JSON.stringify(this.statMap);

          sub.next('stats');
          sub.complete();
        })
      })
    } else {
      return of('a');
    }
  }
}
